import React from 'react';

const UserIcon = () => {
      return (
            <>
                  <span className="material-symbols-outlined">person</span>
            </>
      );
};

export default UserIcon;
